import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { RouterModule } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeUa from '@angular/common/locales/ru-UA';
import { AppComponent } from './app.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { AppRoutingModule } from './app-routing.module';
import { HomePageComponent } from './home-page/home-page.component';
import {HttpClientModule} from '@angular/common/http';
import { ResearchListComponent } from './component/research-list/research-list.component';
import {NgxPaginationModule} from 'ngx-pagination';
import {Ng2SmartTableModule} from 'ng2-smart-table';
import {
  MatAutocompleteModule,
  MatButtonModule, MatButtonToggleModule, MatDatepickerModule,
  MatDialogModule, MatFormFieldModule,
  MatInputModule, MatNativeDateModule, MatPaginatorModule, MatProgressSpinnerModule, MatSelectModule,
  MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule
} from '@angular/material';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import { ResearchDetailsDialogComponent } from './component/research-details-dialog/research-details-dialog.component';
import { FilterPanelComponent } from './component/filter-panel/filter-panel.component';
import {ResearchDetailsComponent} from './component/research-details-dialog/research-details/research-details.component';

registerLocaleData(localeUa, 'ua');

@NgModule({
  declarations: [
    AppComponent,
    LoginPageComponent,
    HomePageComponent,
    ResearchListComponent,
    ResearchDetailsDialogComponent,
    FilterPanelComponent,
    ResearchDetailsComponent,
    ResearchDetailsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    Ng2SmartTableModule,
    MatTableModule,
    MatPaginatorModule,
    NoopAnimationsModule,
    MatToolbarModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatTabsModule
  ],
  entryComponents: [
    ResearchDetailsDialogComponent
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
